import React from 'react';
import { IImage } from '../interfaces/IImage';
import myConfiguredSanityClient from '../../sanityClient'
import imageUrlBuilder from '@sanity/image-url'
import { useTheme } from '@mui/material';

const builder = imageUrlBuilder(myConfiguredSanityClient)

function urlFor(source:IImage) {
  return builder.image(source)
}

const CmsImage : React.FC<IImage> = (image) => {
    const theme = useTheme();

    return <>
        <picture>
            <source media={`(min-width:${theme?.breakpoints?.values?.xl}px)`} srcSet={urlFor(image).width(theme?.breakpoints?.values?.xl).url()} />
            <source media={`(min-width:${theme?.breakpoints?.values?.lg}px)`} srcSet={urlFor(image).width(theme?.breakpoints?.values?.xl).url()} />
            <source media={`(min-width:${theme?.breakpoints?.values?.md}px)`} srcSet={urlFor(image).width(theme?.breakpoints?.values?.lg).url()} />
            <source media={`(min-width:${theme?.breakpoints?.values?.sm}px)`} srcSet={urlFor(image).width(theme?.breakpoints?.values?.md).url()} />
            <source media={`(min-width:${theme?.breakpoints?.values?.xs}px)`} srcSet={urlFor(image).width(theme?.breakpoints?.values?.sm).url()} />
            <img width={'100%'} src={urlFor(image).width(theme?.breakpoints?.values?.lg).url()} alt={image?.name} />
        </picture>
    </>
}

export default CmsImage;